import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import { ITooltipProps } from "./Tooltip.interface";

import "./Tooltip.scss";

const ToolTipComponent: React.FC<ITooltipProps> = (props: ITooltipProps) => {
  const { targetId, children } = props;

  return (
    <UncontrolledTooltip target={targetId}>{children}</UncontrolledTooltip>
  );
};

export default ToolTipComponent;
